import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Importer les CSS dans le bon ordre
import './styles/custom.css';
import './styles/alert-animations.css';
import './index.css';
import './CounterApp.css';

// Context pour la configuration
import { ConfigProvider } from './contexts/ConfigContext';
import { SocketProvider } from './contexts/SocketContext';
import { AuthProvider } from './contexts/AuthContext';
import { SocketStatProvider } from './contexts/SocketStatContext';
 

// Fournisseur de styles dynamiques
import DynamicStylesProvider from './components/DynamicStylesProvider';

// Pages
// NB : l'admin/config est désormais l'application autonome « TicketFlow-admin »
// (apps/admin). L'UI admin legacy (route /admin + AdminPanel + DefaultLayout)
// a été retirée ici — restaurable via le tag git `pre-b4-legacy-admin`.
import TicketDistributor from './pages/TicketDistributor';
import DisplayScreen from './pages/DisplayScreen';
import CounterApp from './pages/CounterApp';
import AuditPage from './pages/Audit';
import Manage from './pages/Manage';
import DisplaysManager from './pages/DisplaysManager';
import SoundSettings from './pages/SoundSettings';
import NumberingSettings from './pages/NumberingSettings';
import DistributorTicker from './pages/DistributorTicker';
import CentralConfig from './pages/CentralConfig';
import NotFound from './pages/NotFound';
import Setup from './pages/Setup';
import HowToUse from './pages/HowToUse';



// Pages d'authentification
import LoginPage from './pages/Login';
import UnauthorizedPage from './pages/Unauthorized';

// Composants de protection des routes
import ProtectedRoute from './components/ProtectedRoute';
import EnrollmentBanner from './components/EnrollmentBanner';
import DefaultPasswordNotice from './components/DefaultPasswordNotice';
import ChangePassword from './pages/ChangePassword';
import Backup from './pages/Backup';
import ManifestePoste from './components/ManifestePoste';


function App() {
  // S'assurer que le body a une classe par défaut
  useEffect(() => {
    document.body.classList.add('global-panel');
    
    return () => {
      document.body.classList.remove('global-panel');
    };
  }, []);

  return (
    
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
        <SocketStatProvider>
          
          <ConfigProvider>
            <DynamicStylesProvider>
              {/* Bandeau « serveur non relié ». Hors <Routes> pour surplomber la page, mais il ne
                  s'affiche QUE sur /manage — le seul écran dont l'occupant peut agir (la saisie du
                  code exige un admin). Il s'efface de lui-même une fois le site approuvé. */}
              <EnrollmentBanner />
              <DefaultPasswordNotice />
              {/* Manifeste PWA selon la page : le guichet installé depuis /counter rouvre /counter
                  (et non la racine, qui mène au distributeur). Sans rendu. */}
              <ManifestePoste />
              <Routes>
                {/* Route setup (publique, hors layout) */}
                <Route path="/setup" element={<Setup />} />

                {/* Routes publiques */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />
                <Route path="/how-to-use" element={<HowToUse />} />
                <Route path="/distributor" element={<TicketDistributor />} />
                <Route path="/display" element={<DisplayScreen />} />
                {/* /display-grid & /display-grid-new supprimées : la grille est désormais
                    un MODE de /display (config.display.layout = 'grid'), pilotée console. */}

                {/* Redirection de la page d'accueil vers le distributeur */}
                <Route path="/" element={<Navigate to="/distributor" />} />

                {/* Admin legacy retiré (B4) — désormais l'app autonome TicketFlow-admin.
                    Une visite de /admin retombe sur la 404 ci-dessous. */}

                {/* Administration (admin/manager) : menu → Audit / Config (connexion au central) */}
                <Route element={<ProtectedRoute allowedRoles={['admin', 'manager']} />}>
                  <Route path="/manage" element={<Manage />} />
                  <Route path="/displays" element={<DisplaysManager />} />
                  <Route path="/sound" element={<SoundSettings />} />
                  <Route path="/numbering" element={<NumberingSettings />} />
                  <Route path="/ticker" element={<DistributorTicker />} />
                  <Route path="/audit" element={<AuditPage />} />
                  <Route path="/config" element={<CentralConfig />} />
                  {/* Sauvegardes : réservées admin/manager. Lister les archives, c'est déjà
                      révéler ce que le site possède ; les restaurer, c'est écraser sa base. */}
                  <Route path="/backup" element={<Backup />} />
                </Route>

                {/* Routes protégées pour tous les utilisateurs authentifiés */}
                <Route element={<ProtectedRoute allowedRoles={['admin', 'manager', 'agent']} />}>
                  <Route path="/counter" element={<CounterApp />} />
                  {/* Tout utilisateur authentifié — y compris un agent — doit pouvoir changer SON
                      mot de passe. Le réserver aux admins interdirait à un agent de protéger son
                      propre compte, ce qui n'a aucun sens. */}
                  <Route path="/change-password" element={<ChangePassword />} />
                </Route>
                
                {/* Page 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              
              {/* Notifications Toast */}
              <ToastContainer position="top-right" autoClose={3000} />
            </DynamicStylesProvider>
          </ConfigProvider>
          </SocketStatProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>


    // // // // <BrowserRouter>
    // // // //   <SocketProvider>
    // // // //     <ConfigProvider>
    // // // //       <DynamicStylesProvider>
    // // // //         <Routes>
    // // // //           {/* Redirection de la page d'accueil vers le distributeur */}
    // // // //           <Route path="/" element={<Navigate to="/distributor" />} />
              
    // // // //           {/* Routes pour les différentes interfaces */}
    // // // //           <Route path="/admin" element={
    // // // //             <DefaultLayout>
    // // // //               <AdminPanel />
    // // // //             </DefaultLayout>
    // // // //           } />
              
    // // // //           <Route path="/distributor" element={<TicketDistributor />} />
    // // // //           <Route path="/display" element={<DisplayScreen />} />
    // // // //           <Route path="/counter" element={<CounterApp />} />
              
    // // // //           {/* Page 404 */}
    // // // //           <Route path="*" element={<NotFound />} />
    // // // //         </Routes>
            
    // // // //         {/* Notifications Toast */}
    // // // //         <ToastContainer position="top-right" autoClose={3000} />
    // // // //       </DynamicStylesProvider>
    // // // //     </ConfigProvider>
    // // // //   </SocketProvider>
    // // // // </BrowserRouter>
  );
}

export default App;
